import React, {useEffect, useState} from 'react';

// custom components
import {Footer, Text, PageNavigator } from '../../components/atoms';
import { ApiTitle, TabList, List, TableNumber, Callout, RequestHeader, RequestFields, HttpRequest} from '../../components/molecules';

// bootstrap
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import SwaggerUI from "swagger-ui-react";

// custom components
import { Maintenance } from '../../components/atoms';
import { IntegrationRow } from '../../components/organisms';

// code
import sample from '../../utils/code/postBookingBody';
import { CopyBlock, dracula} from "react-code-blocks";

// utils
import { Colors } from '../../styles';

// images
import UpdatedAirlineBooking from '../../assets/images/update-booking/airline-update.png';
import UpdatedPRMBooking from '../../assets/images/update-booking/prm-updated.png';

const codeStyle = {
    fontFamily: 'monospace',
    fontSize: 16,
    backgroundColor: '#f0f0f0',
    color: "#000000",
    padding: 4,
    borderRadius: 4,
};

const UpdateBooking = (props) => {

    const [tab, setTab] = useState(0)

    useEffect(() => {

    }, []);

    const TitleText = (props) => { return ( <p style={{ fontWeight:'bold', fontSize:14 }}>{props.children}</p>)}
    const TextText = (props) => { return ( <p style={{ fontWeight:'300', fontSize:14 }}>{props.children}</p>)}

    const ExampleBookingTable = (props) => {

        const Row = (props) => { return (
            <tr>
                <td><TitleText>{props.data}</TitleText></td>
                <td><TextText>{props.example}</TextText></td>
            </tr>
        )}

        return (
            <div style={{ }}>
                <table class="table" style={{ }}>
                        <thead style={{}}>
                            <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                                <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Data</th>
                                <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col">Value</th>
                            </tr>
                        </thead>
                    <tbody>
                        <tr>
                            <td><TitleText>{'Booking Id'}</TitleText></td>
                            <td><TextText>{'EI205-2022-01-01-joe-bloggs'}</TextText></td>
                        </tr>
                        <Row data={'Passenger Name'} description={'The name of the passenger'} example={'Mr. Joe Bloggs'} required={'Yes'} />
                        <Row data={'Origin Airport IATA'} description={'The IATA code of the origin airport'} example={'DUB'} required={'Yes'} />
                        <Row data={'Destination Airport IATA'} description={'The IATA code of the destination airport'} example={'JFK'} required={'Yes'} />
                        <Row data={'Flight Number'} description={'The flight number of the route'} example={'EI105'} required={'Yes'} />
                        <Row data={'Departure Date'} description={'The departure date of the flight'} example={'07-12-2022'} required={'Yes'} />
                        <Row data={'Assistance Requested'} description={'A list of SSR codes.'} example={'[ Wheelchair Access, Impaired Eyesight]'} required={'Yes'} />
                        <Row data={'Equipment Information'} description={'Details of the passengers wheelchair equipment'} example={'Make, Model, Weight, Battery etc.'} required={'Optional'} />
                        <Row data={'Service Animal'} description={'Wether or not the passenger is accomponanied by a service animal'} example={'False'} required={'Optional'} />
                    </tbody>
                </table>
            </div>
        )
    }

    const ResponseTable = (props) => {
        return (
            <div>
                <table class="table" style={{ }}>
                    <thead style={{}}>
                        <tr style={{backgroundColor:Colors.PRM_LIGHT_BLUE}}>
                            <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Code</Text.TableHeader></th>
                            <th style={{fontWeight:'bold', fontSize:14, color:'white' }} scope="col"><Text.TableHeader>Description</Text.TableHeader></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>201 Ok</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the patch was succesful. Returns the patched booking or new booking.'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>400 Bad Request</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>Indicates that there was an error in the request. </Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>403 Unauthorized Access</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the request is unauthorized. Typically the result of not including the Authorization header in the request.'}</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>404 Not Found</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>Indicates that the requested booking was not found.</Text.TableBody></td>
                        </tr>
                        <tr>
                            <td scope="col"><Text.TableHeader bold={true}>500 Internal Server Error</Text.TableHeader></td>
                            <td scope="col"><Text.TableBody>{'Indicates that the request did not go through due to an internal error.'}</Text.TableBody></td>
                        </tr>
                    </tbody>
                </table>
            </div>
        );
    }

    return (
        <>
            {/* Title and Prerequisities */}
            <Row className='mt-5'>
                <Col>
                    <ApiTitle 
                        smallTitle={'PUT Request'}
                        title={'Updating a booking'}
                        subtitle={'Use this guide to learn how to get update bookings from our database.'}
                        prerequisites={[
                            'JSON Web Token',
                            'Booking ID'
                        ]}
                    />
                </Col>
            </Row>

            {/* Overview */}
            <Row>
                <Col>
                    <Text.Subheading>Overview</Text.Subheading>
                    <Text.Text>{`In this section, we explain the process of updating a booking. All of the fields in a booking can be updated, in the case a passenger changes the name of their booking, their flight or the assistance that they require the booking can be updated easily.`}</Text.Text>
                </Col>
            </Row>
            
            {/* Selector Tab List */}
            <Row>
                <Col>
                    <TabList 
                        tabs={['Overview', 'Example', 'Implementation', 'Integration']}
                        setTab={(value)=>{ setTab(value)}}
                    />
                </Col>
            </Row>

            { tab == 1 && 
            <>
            <Row className='mt-4'>
                <Col>
                    <Container>
                        <Text.Subheading>1. Authorization</Text.Subheading>
                        <Text.Text>{'Authentication is achieved by means of a JSON Web Token: '}</Text.Text>
                        <Container>
                            <List list={['Bearer <token>']} />
                        </Container>
                    </Container>
                </Col>
            </Row>

            {/* 2. Booking Information */}
            <Row className='mt-3'>
                <Col>
                    <Container>
                        <Text.Subheading>2. Updatable Booking Information</Text.Subheading>
                        <Text.Text>{'In order to update a specific booking using PRM Connect, a unique id must be used to retrieve the booking. This unique id is typically made up of '}</Text.Text>
                        <Container>
                            <List list={['Flight Number', 'Flight Date', 'Passenger Name']} />
                        </Container>               
                        <Text.Text>{'When performing a booking update we can update all fields (shown in Table 2.1) in the booking. In the case that a passenger needs to change the name or the flight details of their booking, their booking is deleted and a new one is created. This is mandatory in order to maintain coherence betweeen the unique id of their booking and the contents. '}</Text.Text>     
                    </Container>
                </Col>
            </Row>

            {/* 3. Request */}
            <Row className='mt-3'>
                <Col>
                    <Container>
                        <Text.Subheading>3. Request</Text.Subheading>
                        <Text.Text>{'This section describes the PUT Request to update a booking detailing the parameters, an example request and response, JSON schemas for request, responses and error response codes.'}</Text.Text>              
                    </Container>
                </Col>
            </Row>
            
            {/* 3.1 Headers */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.1 Header</Text.Subheading>
                        <Text.Text>{'The request contains the following headers:'}</Text.Text>
                        <RequestHeader />
                    </Container>
                </Col>
            </Row>

            {/* 3.2 Request Fields */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.1 Fields of Request</Text.Subheading>
                        <Text.Text>{''}</Text.Text>
                        <RequestFields rows={[
                            { parameter:'id', description:'The id of the booking to return', example:'EI205-2022-01-01-joe-bloggs'}
                        ]}
                        />
                    </Container>
                </Col>
            </Row>


            {/* 3.2 Request Body */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.1 Request Body</Text.Subheading>
                        <Text.Text> As mentioned, the request body includes the fields that are being patched. In the case where the <span style={codeStyle}>name</span> or <span style={codeStyle}>flightDetails</span> fields need to be patched, a whole new booking is created and the old one is deleted in order to maintain coherence between the unique id of the booking and the contents. When patching these fields, the response will be the newly created booking, otherwise the original booking is updated in place.</Text.Text>
                    </Container>
                </Col>
            </Row>

            {/* 3.3 Response */}
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <Text.Subheading>3.3 Request Response</Text.Subheading>
                        <Text.Text>{'This section reviews the different responses and their meaning.'}</Text.Text>
                        <ResponseTable />
                    </Container>
                </Col>
            </Row>
            </>
            }

            { tab == 2 &&
            <>
            <Row className='mt-4'>
                <Col >
                   <Container>

                       {/* Text */}
                       <Text.Subheading>1. Example Request</Text.Subheading>
                       <Text.Text>{'This section contains an example of requesting a passenger update'}</Text.Text>

                       <Text.Subsubheading>1.1 Updating a booking to include a service animal</Text.Subsubheading>
                       <Text.Text>{'In this example we get a update a booking for a passenger, Joe Bloggs, to include that they will have a service animal with them. In order to do this, we need to update the serviceAnimal field in the booking'}</Text.Text>
                       
                       <Text.Subsubheading>1.1.1 Request</Text.Subsubheading>
                       <HttpRequest 
                            requestType={'PATCH'}
                            url={'https://connect.prmassist.com/api/v1/bookings/EI205-2022-01-01-joe-bloggs'}
                            headers={['Authorization: Bearer <token>', 'Content-Type: application/json',]}
                            body={'{ serviceAnimal: true}'}
                        />
                   </Container>
               </Col>
           </Row>
            <Row className='mt-2'>
                <Col>
                    <Container>
                        <TableNumber title={'1.1 Request Response'} description={'Displays the response from the above request'} />
                        <CopyBlock
                            language={'json'}
                            text={sample['patchResponse']}
                            showLineNumbers={false}
                            theme={dracula}
                            wrapLines={false}
                        />
                    </Container>
                </Col>
            </Row>
            </>
            }

            {/* Request */}
            { tab === 3 &&
            <>
                <Row className='mt-4'>
                    <Col>
                        <Container>
                            <Text.Subheading>Swagger Implementation</Text.Subheading>
                            <Text.Text>{'This section contains a swagger that can be used for getting a single booking using a booking id, reviewing the different responses and error codes'}</Text.Text>
                            <SwaggerUI url="patch_booking.yaml" />
                        </Container>
                    </Col>
                </Row>
            </>
            }

            {/* Integration */}
            { tab === 4 && 
            <>
                <IntegrationRow 
                    title={'1. Edited Booking'}
                    description={'In this section, we examine how PRM Connect works to update the client on changes and the client updates PRM Assist on changes. There are two possible scenario requirements of updating a booking'}
                    other={<List list={['A Passenger Updates a Booking with the Airline', 'A Passenger Updates a Booking with PRM Assist' ]} />}
                />
                <IntegrationRow 
                    title={'1.1 A Passenger Updates a Booking with the Airline'}
                    description={'A passenger has made an assistance booking with Aer Lingus. This booking is then shared with PRM Assist. Subsequently, the passenger updates their booking to include a service animal, this scenario explains how this updated information is then shared with PRM Assist.'}

                    imageTitle={<TableNumber title={'1.1 Updated Airline Booking'} description={'Example of a booking stored in the airline database being updated from the PRM Connect database'} />}
                    image={<img
                        src={UpdatedAirlineBooking}
                        width="1000px"
                        className="d-inline-block align-top"
                        alt=""
                        style={{}}
                    />}
                />
                <IntegrationRow 
                    title={'1.2 A Passenger Updates a Booking with PRM Connect'}
                    description={'A passenger has made an assistance booking with PRM Assist. This booking is then shared with the Airline. Subsequently, the passenger updates their booking to include a service animal, this scenario explains how this updated information is then shared with the airline.'}

                    imageTitle={<TableNumber title={'1.2 Updated PRM Booking'} description={'Example of a booking stored in the PRM Booking database being updated on both databases'} />}
                    image={<img
                        src={UpdatedPRMBooking}
                        width="1000px"
                        className="d-inline-block align-top"
                        alt=""
                        style={{}}
                    />}
                />
            </>
            }

            {/* Page Navigator */}
            <Row>
                <Col>
                    <Container>
                        <PageNavigator leftText={'Getting Multiple Bookings'} leftLink={'/getting-bookings'}  rightText={'Delete Bookings'} rightLink={'/delete-bookings'} />
                    </Container>
                </Col>
            </Row>
            
            <Footer small={true} />
        </>
    );
};

export default UpdateBooking;
